import CheckmarkIcon from '@curology/ui-components-web/react/Icon/icons/CheckmarkIcon';
import CrossIcon from '@curology/ui-components-web/react/Icon/icons/CrossIcon';
import { useAtom } from 'jotai';

import { FlashMessagesState } from './flashMessagesState';

const useFlashMessages = () => {
  const [flashMessages, setFlashMessages] = useAtom(
    FlashMessagesState.flashMessagesAtom,
  );

  const success = ({
    title = 'Success!',
    message,
  }: {
    title: string;
    message: string;
  }) => {
    setFlashMessages((prev) => [
      ...prev,
      {
        children: <div dangerouslySetInnerHTML={{ __html: message }} />,
        icon: <CheckmarkIcon />,
        iconSize: 'sm',
        state: 'success',
        title,
      },
    ]);
  };

  const error = ({
    title = 'Sorry!',
    message,
  }: {
    title?: string;
    message: string;
  }) => {
    setFlashMessages((prev) => [
      ...prev,
      {
        children: <div dangerouslySetInnerHTML={{ __html: message }} />,
        icon: <CrossIcon />,
        iconSize: 'sm',
        state: 'critical',
        title,
      },
    ]);
  };

  return { success, error };
};

export { useFlashMessages };
